import gql from 'graphql-tag';
import { graphql } from 'react-apollo';
import { compose } from 'recompose';
import { withRouter } from 'react-router';

import { withSnackbarContextActions } from 'Store/SnackbarContext';
import { reportGraphqlError } from 'Helpers/graphqlResponseUtil';

export const CANCEL_ORDER = gql`
  mutation cancelOrder($input: CancelOrderInput!) {
    cancelOrder(input: $input) {
      error
      order {
        id
        createdAt
        fee
        notes
        successor
        total
      }
      success
    }
  }
`;

export const withCancelOrder = graphql(CANCEL_ORDER, {
  props: ({ mutate }) => ({
    cancelOrder: input => mutate({ variables: { input } })
  }),
  options: props => ({
    onCompleted: async data => {
      if (data.cancelOrder && data.cancelOrder.error) {
        reportGraphqlError(props.showSnackbar, 'There was an error cancelling the order', data.cancelOrder.error);
        return;
      }
      props.showSnackbar('Order successfully cancelled');
    },
    onError: async error => {
      reportGraphqlError(props.showSnackbar, 'There was an error cancelling the order', error);
    }
  })
});

// pretter-ignore
export default compose(withRouter, withSnackbarContextActions, withCancelOrder);
